// extracted by mini-css-extract-plugin
module.exports = {"ant-spin-dot-item":"Releases_ant-spin-dot-item__3U9I-"};